<template>
<div>

  <DraggableDiv>
    <template slot="header">
      <h3>
        Notes for {{ data.noteType }} : {{data.orderNo ? data.orderNo : ""}}
      </h3>
    </template>
    <template slot="main">

      <section v-show="!showEditor && notes.length > 0 && !processing">
        <vue-custom-scrollbar class="scroll-area" :settings="settings">

          <single-note v-for="note in notes" v-bind:key="note.id" :note="note" />

        </vue-custom-scrollbar>
      </section>
      <section v-show="!showEditor && notes.length == 0 && !processing">No notes to display</section>
      <section class="text-center" v-show="processing">
        <b-spinner small></b-spinner>
      </section>
      <note-editor :show-editor="showEditor" :data="data" />

    </template>

    <template slot="footer">

      <div class="actions">
        <div>
          <b-button :variant="showEditor ? 'danger' : 'success'" size="xs" @click="showEditor = !showEditor" :disabled="!data.noteType">{{ showEditor ? "Show Notes" : "+ Add Notes"}}</b-button>
        </div>
        <div>
          <a href="#" class="text-danger" @click.prevent="noteClosed">Close</a>
        </div>
      </div>

    </template>

  </DraggableDiv>
</div>
</template>

<script>
import NoteEditor from './note-editor';
import EventBus from '../../EventBus'
import DraggableDiv from '../../components/orders/draggable-div'
import SingleNote from './single-note'
import NoteService from "../../services/note.service"
import vueCustomScrollbar from 'vue-custom-scrollbar'
export default {
  data() {
    return {
      data: {
        recordId: null,
        noteType: '',
        orderNo: '',
      },
      notes: [],
      noteDeletedNoteCount: 0,
      showEditor: false,
      settings: {
        maxScrollbarLength: 60,
        useBothWheelAxes: true,
        swipeEasing: true,
      },
      processing: false
    }
  },
  mounted() {
    EventBus.$on("access-notes", (data) => {
      this.data.noteType = data.noteType
      this.data.orderNo = data.orderNo
      this.data.recordId = data.recordId

      this.fetchNotes(data.noteType, data.recordId)

    })

    EventBus.$on("note-deleted", () => {
       this.fetchNotes(this.data.noteType, this.data.recordId)
    })

    EventBus.$on("added-or-edited-note", (data) => {
      this.fetchNotes(data.noteType, data.recordId);
    })

    EventBus.$on("edit-note", ({id, noteContent}) => {
        this.showEditor = true;
    })
  },
  methods: {
    async fetchNotes(noteType, recordId = 0) {
      try {

        this.processing = true;

        const result = await NoteService.fetchNotes(noteType, recordId);

        this.processing = false;

        this.notes = result.data.notes;
        this.showEditor = false;
        this.noteDeletedNoteCount = 0;
        result.data.notes.forEach(note => {
           if(!note.deletedAt){
             this.noteDeletedNoteCount++;
           }
        })

        EventBus.$emit('update-note-count', {recordId: this.data.recordId, count: this.noteDeletedNoteCount, noteType: noteType})
        
      } catch (errors) {
        console.log("errors ", errors)
      }
    },
    noteClosed() {
      EventBus.$emit('note-closed');
      this.data.recordId = null;
      this.data.noteType = '';
      this.data.orderNo = '';
    }
  },
  components: {
    DraggableDiv,
    NoteEditor,
    SingleNote,
    vueCustomScrollbar
  },
  beforeDestroy() {
    EventBus.$off("access-notes")
    EventBus.$off("added-or-edited-note");
    EventBus.$off("edit-note");
  }
}
</script>

<style lang="scss" scoped>
.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 300px;
  padding-right: 15px;
}

.actions {
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  margin: 5px 0;
}
</style>
